<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="عن-المؤلف">
<h1><span dir="rtl">عن المؤلف</span></h1>
<p><span dir="rtl">بسمة بني حماد مهندسة كيميائية، خرِّيجة جامعة الإمارات العربية المتحدة، وتشغل حاليا منصب مديرة لقسم عمليات الإنتاج البترولية</span>.</p>
<p><span dir="rtl"><br/>
</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?2dba880e